import React from "react";

var WarningIcon = function WarningIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "40",
    viewBox: "0 0 20 40",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53125 21.125C2.125 20.4375 2.125 19.5938 2.53125 18.875L5.28125 14.125C5.6875 13.4062 6.4375 13 7.21875 13H12.75C13.5625 13 14.2812 13.4062 14.6875 14.125L17.4375 18.875C17.8438 19.5938 17.8438 20.4375 17.4375 21.125L14.6875 25.9062C14.2812 26.625 13.5625 27.0312 12.75 27.0312H7.21875C6.4375 27.0312 5.6875 26.625 5.28125 25.9062L2.53125 21.125ZM10 16C9.5625 16 9.25 16.3438 9.25 16.75V20.25C9.25 20.6875 9.5625 21 10 21C10.4062 21 10.75 20.6875 10.75 20.25V16.75C10.75 16.3438 10.4062 16 10 16ZM11 23C11 22.4688 10.5312 22 10 22C9.4375 22 9 22.4688 9 23C9 23.5625 9.4375 24 10 24C10.5312 24 11 23.5625 11 23Z",
    fill: "#DC0A0A"
  }));
};

export default WarningIcon;